(function () {
  const SECTION_ORDER = [
    'intro',
    'product_inspiration',
    'includes',
    'contentpack',
    'mainingredients',
    'pyramid',
    'aromatic',
    'finish',
    'inspiration',
    'ingredient',
    'ingredients',
    'functions',
    'fragances',
    'fragancess',
    'features',
    'smell',
    'forwhat',
    'effect',
    'whylike',
    'whyselect',
    'how',
    'recommended',
    'recommendedd',
    'usage',
    'usagee',
    'why'
  ];

  const ACCORDION_SECTIONS = ['includes', 'product_inspiration', 'contentpack', 'mainingredients', 'pyramid', 'aromatic', 'inspiration', 'ingredient', 'ingredients', 'functions', 'fragances', 'fragancess', 'features', 'smell', 'forwhat', 'effect', 'whylike', 'whyselect'];

  const TITLES = {
    includes: '¿Qué incluye?',
    contentpack: 'Contenido del pack',
    mainingredients: 'Ingredientes principales',
    pyramid: 'Pirámide olfativa',
    aromatic: 'Notas aromáticas',
    finish: '¿Cómo es su acabado?',
    inspiration: 'Inspiración olfativa',
    ingredient: 'Ingrediente destacado',
    ingredients: 'Ingredientes destacados',
    functions: null,
    fragances: 'Fragancias disponibles',
    fragancess: 'Aromas disponibles',
    features: 'Características',
    smell: '¿A qué huele?',
    forwhat: '¿Para qué sirven?',
    effect: '¿Qué efecto consigue?',
    whylike: '¿Por qué te gustará?',
    whyselect: '¿Por qué elegir?',
    how: '¿Cómo actúa?',
    recommended: '¿Para quién está recomendado?',
    recommendedd: '¿Para quién está recomendada?',
    usage: 'Modo de empleo',
    usagee: 'Modo de uso',
    why: '¿Por qué comprar en Laureia Shop?'
  };

  function getSectionTitle(key) {

  const product = productTitle();

  switch (key) {

    case 'functions':
      return `¿Qué hace ${product}?`;

    case 'inspiration':
      return `Pirámide olfativa`;

    case 'contentpack':
      return `¿Qué incluye?`;

    case 'why':
      return `¿Porqué comprar en Laureia Shop?`;

    case 'whylike':
      return `¿Porqué te gustará?`;

    case 'usagee':
      return `Modo de empleo`;

    case 'whyselect':
      return `¿Porqué elegir ${product}?`;

    case 'effect':
      return `¿Qué efecto consigue ${product}?`;

    case 'aromatic':
      return `Pirámide olfativa`;

    case 'recommendedd':
      return `¿Para quién está recomendado?`;

    case 'product_inspiration':
      return `Inspiración`;

    default:
      return TITLES[key];
  }

}

function productTitle() {
  const title =
    document.querySelector('.product__title h2') ||
    document.querySelector('h2.product__title') ||
    document.querySelector('h2');

  if (!title) return 'este producto';

  return title ? title.textContent.split(/\s*[-–—|]\s*/)[0].trim() : 'este producto';
}

  const TICK_RE = /^[\s✓✔✅âœ”]+/i;

  function fixText(text) {
    return text
      .replace(/Ã¡/gi, 'á')
      .replace(/Ã©/gi, 'é')
      .replace(/Ã­/gi, 'í')
      .replace(/Ã³/gi, 'ó')
      .replace(/Ãº/gi, 'ú')
      .replace(/Ã±/gi, 'ñ')
      .replace(/Ã/g, 'Á')
      .replace(/Ã‰/g, 'É')
      .replace(/Ã/g, 'Í')
      .replace(/Ã“/g, 'Ó')
      .replace(/Ãš/g, 'Ú')
      .replace(/Ã‘/g, 'Ñ')
      .replace(/Â/g, '')
      .replace(/âœ”/gi, '✔');
  }

  function cleanSpaces(text) {
    return text.replace(/\s+/g, ' ').trim();
  }

  function normalize(text) {
    return fixText(text)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[¿?]/g, '')
      .replace(/[.:]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function nodeText(node) {
    return cleanSpaces(fixText(node.textContent || ''));
  }

  /*function normalizeTopLevelNodes(container){

    Array.from(container.children).forEach(function(node){

        // Solo los span "huérfanos"
        if(node.tagName !== 'SPAN')
            return;

        // Solo si tienen texto
        if(!nodeText(node))
            return;

        // Solo si parecen un encabezado
        if(!node.querySelector('strong,b'))
            return;

        const p = document.createElement('p');

        p.appendChild(node.cloneNode(true));

        node.replaceWith(p);

    });

  }*/

  /*function removeEmptyParagraphs(container){

    container.querySelectorAll('p').forEach(function(p){

        if(nodeText(p))
            return;

        if(p.querySelector('img,video,iframe'))
            return;

        p.remove();

    });

  }*/

  function sectionKeyFromText(text) {
    const value = normalize(text);

    if (value.includes('que incluye')) return 'includes';
    if (value.includes('contenido del pack')) return 'contentpack';
    if (value.includes('caracteristicas')) return 'features';
    if (value.indexOf('ingrediente destacado') === 0) return 'ingredient';
    if (value.indexOf('ingredientes destacados') === 0) return 'ingredients';
    if (value.indexOf('que hace') === 0) return 'functions';
    if (value.indexOf('piramide olfativa') === 0) return 'pyramid';
    if (value === 'ingredientes principales') return 'mainingredients';
    if (value.indexOf('notas aromaticas') === 0) return 'aromatic';
    if (value.includes('como es su acabado')) return 'finish';
    if (value.indexOf('piramides olfativas') === 0) return 'pyramid';
    if (value.indexOf('inspiracion olfativa') === 0) return 'inspiration';
    if (value === 'inspiracion') return 'product_inspiration';
    if (value.includes('fragancias disponibles')) return 'fragances';
    if (value.includes('aromas disponibles')) return 'fragances';
    if (value.indexOf('a que huele') === 0) return 'smell';
    if (value.indexOf('para que sirven') === 0) return 'forwhat';
    if (value.includes('que efecto consigue')) return 'effect';
    if (value.indexOf('como actua') === 0) return 'how';
    if (value === 'para quien esta recomendado') return 'recommended';
    if (value === 'para quien esta recomendada') return 'recommendedd';
    if (value.includes('por que te gustara')) return 'whylike';
    if (value.includes('por que elegir')) return 'whyselect';
    if (value === 'modo de empleo') return 'usage';
    if (value === 'modo de uso') return 'usagee';
    if (value.includes('por que comprar en laureia shop')) return 'why';

    return null;
  }

  function hasContent(nodes) {
    return nodes.some(function (node) {
      return nodeText(node) || (node.querySelector && node.querySelector('img, video, iframe, table'));
    });
  }

  function collectSections(container) {
    const sections = { intro: [] };
    let currentKey = 'intro';

    /*console.log("CHILDNODES");
    console.log(container.childNodes);

    console.log("QUERY P");
    console.log(container.querySelectorAll("p"));*/

    Array.from(container.querySelectorAll('p, ul, ol, table, iframe')).forEach(function (node) {
      const key = sectionKeyFromText(nodeText(node));

      /*if (
          node.tagName === 'SPAN' &&
          !node.querySelector('strong,b')
      ) {
          return;
      }*/

      if (key) {
        currentKey = key;
        sections[currentKey] = sections[currentKey] || [];
        return;
      }

      sections[currentKey] = sections[currentKey] || [];
      sections[currentKey].push(node.cloneNode(true));
    });

    return sections;
  }

  function removeLeadingTickFromElement(element) {
    if (!TICK_RE.test(nodeText(element))) return;

    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();

    while (textNode) {
      if (textNode.nodeValue.trim()) {
        textNode.nodeValue = fixText(textNode.nodeValue).replace(TICK_RE, '').trimStart();
        return;
      }

      textNode = walker.nextNode();
    }
  }

  function makeListItem(html) {
    const item = document.createElement('li');
    item.innerHTML = html.replace(TICK_RE, '').trim();

    item.querySelectorAll('strong,b').forEach(function(el){

        while(el.firstChild){
            el.parentNode.insertBefore(el.firstChild,el);
        }

        el.remove();

    });

    removeLeadingTickFromElement(item);
    return item;
  }

  function paragraphTickList(paragraph) {
    const html = paragraph.innerHTML.replace(/âœ”/gi, '✔');

    if (!/[✓✔✅]/.test(html)) return null;

    const pieces = html
      .split(/<br\b[^>]*\/?>/gi)
      .map(function (piece) {
        return piece.trim();
      })
      .filter(function (piece) {
        return piece && /[✓✔✅]/.test(piece);
      });

    if (pieces.length < 2) return null;

    const list = document.createElement('ul');
    list.className = 'laureia-description__list';

    pieces.forEach(function (piece) {
      list.appendChild(makeListItem(piece));
    });

    return list;
  }

  function cleanLists(container) {
    Array.from(container.querySelectorAll('ul')).forEach(function (list) {
      list.classList.add('laureia-description__list');

      Array.from(list.children).forEach(function (item) {
        removeLeadingTickFromElement(item);
      });
    });

    Array.from(container.querySelectorAll('p')).forEach(function (paragraph) {
      const list = paragraphTickList(paragraph);

      if (list) {
        paragraph.replaceWith(list);
      }
    });
    paragraphTickGroups(container);
  }

  function paragraphTickGroups(container){

    const children = Array.from(container.children);

    for(let i=0;i<children.length;i++){

        const node = children[i];

        if(node.tagName!=='P')
            continue;

        if(!TICK_RE.test(nodeText(node)))
            continue;

        const list=document.createElement('ul');
        list.className='laureia-description__list';

        let j=i;

        while(j<children.length){

            const p=children[j];

            if(p.tagName!=='P')
                break;

            if(!TICK_RE.test(nodeText(p)))
                break;

            list.appendChild(
                makeListItem(p.innerHTML)
            );

            j++;

        }

        children[i].before(list);

        for(let k=i;k<j;k++)
            children[k].remove();

        i=j-1;

    }

  }

  function plainTextElement(text, className) {
    const element = document.createElement('p');
    element.className = className;
    element.textContent = text;
    return element;
  }

  function noteHeadingText(text) {
    const value = normalize(text);

    if (value === 'notas salida' || value === 'notas de salida') return 'Notas de salida';
    if (value === 'notas corazon' || value === 'notas de corazon') return 'Notas de corazón';
    if (value === 'notas fondo' || value === 'notas de fondo') return 'Notas de fondo';

    return null;
  }

  function perfumeTitleFromText(text) {
    return cleanSpaces(text)
      .replace(/\s*\([^)]*\)\s*$/, '')
      .replace(/\s*[.:]+$/, '')
      .trim();
  }

  function makeDetails(title, className) {
    const details = document.createElement('details');
    const summary = document.createElement('summary');

    details.className = className;
    summary.className = 'laureia-description__summary h4 laureia-description__title';
    summary.textContent = title;

    details.appendChild(summary);

    return details;
  }

  function createContent(nodes) {
    const content = document.createElement('div');
    content.className = 'laureia-description__content';

    nodes.forEach(function (node) {

        const fixedNoteTitle = noteHeadingText(nodeText(node));

        if (fixedNoteTitle) {

            content.appendChild(
            plainTextElement(
                fixedNoteTitle,
                'laureia-description__note-title'
            )
            );
        }else{
          content.appendChild(node);
        }
      });

    cleanLists(content);

    return content;
  }

  function newOlfactoryBlock(title) {
    return {
      title: perfumeTitleFromText(title),
      nodes: []
    };
  }

  function appendContentNode(state, currentBlock, flatNodes, node) {
    if (currentBlock && state !== 'waiting') {
      currentBlock.nodes.push(node);
    } else {
      flatNodes.push(node);
    }
  }

  function appendPendingNode(flatNodes, pendingNode) {
    if (!pendingNode) return;

    if (pendingNode.block && pendingNode.state !== 'waiting') {
      pendingNode.block.nodes.push(pendingNode.node);
    } else {
      flatNodes.push(pendingNode.node);
    }
  }

  function buildPyramidContent(nodes) {
    const wrapper = document.createElement('div');
    wrapper.className = 'laureia-description__content';

    const blocks = [];
    const flatNodes = [];
    let state = 'waiting';
    let currentBlock = null;
    let pendingTitle = null;

    function addNode(targetState, node) {
      appendContentNode(targetState, currentBlock, flatNodes, node);
    }

    function flushPendingTitle() {
      if (!pendingTitle) return;

      if (pendingTitle.block) {
        pendingTitle.block.nodes.push(pendingTitle.node);
      } else {
        flatNodes.push(pendingTitle.node);
      }

      pendingTitle = null;
    }

    nodes.forEach(function (node) {
      const text = nodeText(node);
      const noteTitle = noteHeadingText(text);

      if (noteTitle) {
        if (noteTitle === 'Notas de salida') {
          state = 'salida';

          if (pendingTitle) {
            currentBlock = newOlfactoryBlock(nodeText(pendingTitle.node));
            blocks.push(currentBlock);
            pendingTitle = null;
          }
        } else {
          flushPendingTitle();
          state = noteTitle === 'Notas de corazón' ? 'corazon' : 'fondo';
        }

        addNode(state, node);
        return;
      }

      if (!text) {
        addNode(state, node);
        return;
      }

      flushPendingTitle();
      pendingTitle = { node: node, block: currentBlock };

      if (state === 'fondo') {
        state = 'waiting';
      }
    });

    flushPendingTitle();

    if (blocks.length < 2) {
      return createContent(nodes);
    }

    if (hasContent(flatNodes)) {
      Array.from(createContent(flatNodes).childNodes).forEach(function (node) {
        wrapper.appendChild(node);
      });
    }

    blocks.forEach(function (block) {
      const details = makeDetails(block.title, 'laureia-description__nested-accordion');
      details.appendChild(createContent(block.nodes));
      wrapper.appendChild(details);
    });

    return wrapper;
  }

  function firstBoldTitle(item) {
    const bold = item.querySelector('b, strong');

    if (!bold) return '';

    const title = nodeText(bold);
    const beforeBold = item.textContent.slice(0, item.textContent.indexOf(bold.textContent));

    if (beforeBold.trim()) return '';

    return perfumeTitleFromText(title);
  }

  function removeFirstBold(element) {
    const bold = element.querySelector('b, strong');

    if (!bold) return;

    const parent = bold.parentNode;
    bold.remove();

    if (parent && !nodeText(parent)) {
      parent.remove();
    }
  }

  function smellListToDetails(list) {
    const items = Array.from(list.children);
    const titles = items.map(firstBoldTitle);

    if (!items.length || titles.some(function (title) { return !title; })) {
      return null;
    }

    const fragment = document.createDocumentFragment();

    items.forEach(function (item, index) {
      const details = makeDetails(titles[index], 'laureia-description__nested-accordion');
      const content = document.createElement('div');
      const copy = item.cloneNode(true);

      content.className = 'laureia-description__content';
      removeFirstBold(copy);
      content.innerHTML = copy.innerHTML.trim();
      cleanLists(content);

      details.appendChild(content);
      fragment.appendChild(details);
    });

    return fragment;
  }

  function buildSmellContent(nodes) {
    const content = createContent(nodes);

    Array.from(content.querySelectorAll('ul')).forEach(function (list) {
      const details = smellListToDetails(list);

      if (details) {
        list.replaceWith(details);
      }
    });

    return content;
  }

  function isPackItemTitle(node){

    if(node.tagName !== 'P')
        return false;

    const text = nodeText(node);

    if(!text)
        return false;

    const value = normalize(text);

    if(text.length > 35)
        return false;

    if(/[.:!?]$/.test(text))
        return false;

    if(value.startsWith('inspirado '))
        return false;

    if(value.startsWith('inspirada '))
        return false;

    if(value.startsWith('este '))
        return false;

    if(value.startsWith('esta '))
        return false;

    if(value.startsWith('el '))
        return false;

    if(value.startsWith('la '))
        return false;

    // El siguiente nodo debe existir
    const next = node.nextElementSibling;

    if(!next)
        return false;

    // Debe ser un párrafo
    if(next.tagName !== 'P')
        return false;

    if(!['P','UL','OL'].includes(next.tagName))
        return false;

    return true;

  }

function buildInspirationContent(nodes) {

    const content = createContent(nodes);

    const children = Array.from(content.children);

    if (children.length < 4)
        return content;

    let intro = [];
    let groups = [];

    let i = 0;

    // -------- INTRODUCCIÓN --------
    while (i < children.length) {

        if (
            isPackItemTitle(children[i]) &&
            i + 1 < children.length &&
            children[i + 1].tagName === 'P'
        ) {
            break;
        }

        intro.push(children[i]);
        i++;
    }

    // -------- GRUPOS --------
    while (i < children.length) {

        const title = children[i];

        if (!isPackItemTitle(title))
            break;

        i++;

        const body = [];

        while (i < children.length) {

            if (
                isPackItemTitle(children[i]) &&
                body.length > 0
            ) {
                break;
            }

            body.push(children[i]);
            i++;
        }

        groups.push({
            title,
            body
        });

    }

    // Si no hay al menos 2 productos NO modificamos nada
    if (groups.length < 2) {
        content.dataset.pack = 'false';
        return content;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'laureia-description__content';

    intro.forEach(node => {
        wrapper.appendChild(node.cloneNode(true));
    });

    groups.forEach(group => {

        const details = makeDetails(
            nodeText(group.title),
            'laureia-description__nested-accordion'
        );

        const body = document.createElement('div');
        body.className = 'laureia-description__content';

        group.body.forEach(node => {

            if (
                node.tagName === 'P' &&
                !nodeText(node)
            ) {
                return;
            }

            body.appendChild(node.cloneNode(true));
        });

        details.appendChild(body);

        wrapper.appendChild(details);

    });

    //console.log(wrapper.innerHTML);

    wrapper.dataset.pack = 'true';

    return wrapper;

  }

  function createSection(key, nodes) {

    let content;

    if (key === 'pyramid') {
        content = buildPyramidContent(nodes);

    } else if (key === 'smell') {
        content = buildSmellContent(nodes);

    } else if (key === 'product_inspiration') {
        content = buildInspirationContent(nodes);

    } else {
        content = createContent(nodes);
    }

    let isAccordion = ACCORDION_SECTIONS.includes(key);

    if (key === 'product_inspiration') {
        isAccordion = content.dataset.pack === 'true';
    }



    //const isAccordion = ACCORDION_SECTIONS.indexOf(key) !== -1;

    

    const section = isAccordion
      ? makeDetails(
        getSectionTitle(key), 
        'laureia-description__accordion laureia-description__section laureia-description__section--' + key
      )
      : document.createElement('section');

    //let content;

    if (!isAccordion) {
      section.className = 'laureia-description__section laureia-description__section--' + key;
    }

    if (key !== 'intro' && !isAccordion) {
      const title = document.createElement('h2');
      title.className = 'h4 laureia-description__title';
      title.textContent = getSectionTitle(key);
      section.appendChild(title);
    }

   /* if (key === 'pyramid') {
      content = buildPyramidContent(nodes);
    } else if (key === 'smell') {
      content = buildSmellContent(nodes);
    } else if (key === 'product_inspiration'){
      content = buildInspirationContent(nodes);
    } else {
      content = createContent(nodes);
    }*/

    section.appendChild(content);

    return section;
  }

  function convertSubHeadings(container) {

    container.querySelectorAll('.laureia-description__content').forEach(function(content){

        if(content.closest('.laureia-description__section--intro')) return;

        const children = Array.from(content.children);

        children.forEach(function(node,index){

            if(node.tagName !== 'P')
                return;

            const text = nodeText(node);

            if(!text)
                return;

            if(sectionKeyFromText(text))
                return;

            if(noteHeadingText(text))
                return;

            if(text.length > 150)
                return;

            if(
                !text.endsWith(':') &&
                !text.endsWith('.:')
            )
                return;

            const next = children[index + 1];

            /*while (
                next &&
                next.tagName === 'P' &&
                !nodeText(next) &&
                !next.querySelector('img')
            ) {
                next = next.nextElementSibling;
            }*/

            if(!next)
                return;

            const validNext = [

                'P',
                'UL',
                'OL',
                'DETAILS',
                'TABLE',
                'IMG',
                'VIDEO',
                'IFRAME'

            ];

            if(!validNext.includes(next.tagName))
                return;

            node.classList.add('laureia-description__subheading');

        });

    });

  }

  function removeRemainingBold(container){

    container.querySelectorAll('strong,b').forEach(function(el){

        if(el.closest('.laureia-description__summary'))
            return;

        if(el.closest('.laureia-description__subheading'))
            return;

        while(el.firstChild){
            el.parentNode.insertBefore(el.firstChild,el);
        }

        el.remove();

    });

  }

  function postProcess(container){

    paragraphTickGroups(container);

    convertSubHeadings(container);

    removeRemainingBold(container);

}

  function render(container) {

    /*console.log("==========");
    console.log("HTML antes del parser:");
    console.log(container.innerHTML);*/

    if (container.dataset.laureiaReady === 'true') return;

    //normalizeTopLevelNodes(container);
    //removeEmptyParagraphs(container);

    const sections = collectSections(container);

    /*Object.entries(sections).forEach(([k,v])=>{
      console.log(k, v?.length);
    });*/

    const fragment = document.createDocumentFragment();

    SECTION_ORDER.forEach(function (key) {
      const nodes = sections[key];

      if (!nodes || !hasContent(nodes)) return;

      fragment.appendChild(createSection(key, nodes));
    });


    /*SECTION_ORDER.forEach(function (key) {

      const nodes = sections[key];

      console.log("-----");
      console.log("KEY:", key);
      console.log("NODES:", nodes);
      console.log("HASCONTENT:", nodes ? hasContent(nodes) : "NO NODES");

      if (!nodes || !hasContent(nodes)) {
          console.log("DESCARTADA");
          return;
      }

      console.log("AÑADIDA");

      fragment.appendChild(createSection(key, nodes));

    });*/


    /*console.log("Fragment:", fragment.childNodes.length);
    console.log(fragment.cloneNode(true));*/

    container.innerHTML = '';
    container.appendChild(fragment);

    /*console.log("ANTES POSTPROCESS");
    console.log(container.innerHTML);*/

    container.classList.add('laureia-description--parsed');

    postProcess(container);

    //console.log(container.innerHTML);

    /*console.log("DESPUES POSTPROCESS");
    console.log(container.innerHTML);*/

    container.dataset.laureiaReady = 'true';
  }

  function init() {
    document.querySelectorAll('.laureia-description').forEach(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
